/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Popup } from 'semantic-ui-react';
import cn from 'classnames';
import { CacheInputs, Portfolio, Storage, Accounts } from 'actions';
import { ACCOUNTS_SAVE_AS_PORTFOLIO, ACCOUNTS_COMPARE } from 'utils/features';
import { Feature } from 'components';
import { nbColors } from 'utils/colors';
import { isGlobeInvestor, isStandalone } from 'utils/helpers';
import SaveModal from './SaveModal';
import './SideBar.css'; // Created css stylesheet as the :before element (arrow) for the new feature popup needed it to be targeted

class NBSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      reminderIsOpen: false,
    };
  }

  componentWillMount() {
    const { ui_compare_checked } = this.props;
    if (!ui_compare_checked) {
      this.setReminderVisibility(true);
    }
  }

  componentWillUnmount() {
    const { dispatch, location, not_save_url_scorecard, history } = this.props;
    const portfolioPaths = /^\/portfolio\/.*$/;
    dispatch(Storage.removeItem('to_scorecard'));

    if (
      not_save_url_scorecard &&
      !portfolioPaths.test(history.location.pathname)
    ) {
      dispatch(CacheInputs.captureUrl('portfolio', '/portfolio/landing'));

      return dispatch(Storage.removeItem('not_save_url_scorecard'));
    }

    return dispatch(CacheInputs.captureUrl('portfolio', location.pathname));
  }

  generatePDF = () => {
    const { history, match, partnerName } = this.props;

    if (isStandalone(partnerName)) {
      return history.push('/scorecard/pdf');
    }

    return history.push(`/portfolio/${match.params.id}/pdf`);
  };

  setReminderVisibility = (isOpen) => this.setState({ reminderIsOpen: isOpen });

  handleReminderClick = () => {
    const { dispatch } = this.props;
    dispatch(Storage.setItem('ui_compare_checked', true));
    dispatch(Accounts.checkUiCompare());
    this.setState({ reminderIsOpen: false });
  };

  isSaveVisible = (portfolio) => {
    const { match, partnerName } = this.props;

    if (!portfolio || isGlobeInvestor(partnerName)) {
      return false;
    }

    if (match.params.id !== 'unsaved') {
      if (!portfolio.is_mp) {
        return false;
      }
    }

    return true;
  };

  redirect = (portfolio) => {
    const { id, history, dispatch } = this.props;

    if (portfolio.name) {
      const port_id = portfolio.is_mp ? '' : id;
      dispatch(
        Portfolio.setEditing(port_id, portfolio.name, portfolio.description)
      );
    }

    if (portfolio.portfolio_type === 'quantified') {
      return history.push(`/portfolio/build-model/${id}`);
    }

    if (
      portfolio.portfolio_type === 'custom' ||
      portfolio.portfolio_type === 'unknown'
    ) {
      if (portfolio.portfolio_sub_type === 'ml_asset_allocation')
        return history.push('/portfolio/build-ml/new');

      return history.push(`/portfolio/build-custom/${id}`);
    }

    return history.push(`/portfolio/build-etf/${id}/assets`);
  };

  closeModal = () => this.setState({ modalIsOpen: false });

  handleClick = (to, name) => {
    const { history } = this.props;

    if (to) {
      return history.push(to);
    }

    return this.setState({ modalIsOpen: name });
  };

  handleCompareClick = () => {
    const { history, id, portfolio, dispatch } = this.props;
    if (portfolio.name) {
      const port_id = portfolio.is_mp ? '' : id;
      dispatch(
        Portfolio.setEditing(port_id, portfolio.name, portfolio.description)
      );
    }
    const portfolioRegex = /^\/portfolio\/.*\/compare$/;
    this.handleReminderClick();
    if (!portfolioRegex.test(history.location.pathname)) {
      return this.handleClick(`/portfolio/${id}/compare`);
    }
    return this.handleClick(`/portfolio/${id}/overview`);
  };

  moreThanOneGic = () => {
    const { portfolio } = this.props;

    return portfolio.gic_info && Object.keys(portfolio.gic_info).length > 1;
  };

  hasTenGic = () => {
    const { portfolio } = this.props;

    return portfolio.gic_info && Object.keys(portfolio.gic_info).length === 10;
  };

  render() {
    const { portfolio, hidden, to_scorecard, french, history } = this.props;
    const { modalIsOpen, reminderIsOpen } = this.state;

    const isCompare = history.location.pathname.includes('/compare');

    return (
      <div>
        <Container hidden={hidden}>
          <ul>
            {/* <Feature name={ACCOUNTS_SAVE_AS_PORTFOLIO}>
              {this.isSaveVisible(portfolio) && !this.moreThanOneGic() && (
                <Popup
                  style={{ zIndex: 3 }}
                  trigger={
                    <li
                      onClick={() => this.handleClick(false, 'save')}
                      className={cn({ active: modalIsOpen === 'save' })}
                    >
                      <button>
                        <i className="ui icon save outline" />
                      </button>
                    </li>
                  }
                  position="right center"
                  content={
                    french
                      ? "Enregistrer ce portefeuille pour l'utiliser dans comparer et planification."
                      : 'Save this portfolio for use in Compare and Planning.'
                  }
                  basic
                  wide
                />
              )}
            </Feature> */}
            {portfolio &&
            (portfolio.portfolio_type === null ||
              portfolio.portfolio_type === undefined ||
              portfolio.is_mp) ? null : (
              <Popup
                style={{ zIndex: 3 }}
                trigger={
                  <li onClick={() => this.redirect(portfolio)}>
                    <button>
                      <i className="ui icon pencil" />
                      <span className="nav-label">
                        {french ? 'Modifier' : 'Edit'}
                      </span>
                    </button>
                  </li>
                }
                position="right center"
                content={
                  french ? 'Modifier ce portefeuille' : 'Edit this Portfolio'
                }
                basic
              />
            )}

            <Feature name={ACCOUNTS_COMPARE}>
              {!this.hasTenGic() && !reminderIsOpen && (
                <Popup
                  style={{
                    zIndex: 3,
                    left: '55px',
                    width:
                      window.location.pathname.split('/').indexOf('compare') !==
                      -1
                        ? '160px'
                        : to_scorecard
                        ? '220px'
                        : '150px',
                  }}
                  trigger={
                    <li
                      onClick={this.handleCompareClick}
                      className={cn({
                        active:
                          window.location.pathname
                            .split('/')
                            .indexOf('compare') !== -1,
                      })}
                    >
                      <button>
                        <i className="ui icon law" />
                        <span className="nav-label">
                          {french ? 'Comparer' : 'Compare'}
                        </span>
                      </button>
                    </li>
                  }
                  position="right center"
                  content={
                    window.location.pathname.split('/').indexOf('compare') !==
                    -1
                      ? french
                        ? 'Retour à la fiche de pointage'
                        : 'Return to Scorecard'
                      : to_scorecard
                      ? french
                        ? 'Retour à Comparer / Et si'
                        : 'Return to Compare / What-if'
                      : french
                      ? 'Comparer / Et si'
                      : 'Compare / What-If'
                  }
                  basic
                />
              )}
              <Popup
                style={{ zIndex: 3 }}
                trigger={
                  <li
                    onClick={() => {
                      if (!isCompare) {
                        this.generatePDF();
                      }
                    }}
                    className={cn({ disabled: isCompare })}
                  >
                    <button type="button" aria-label="Print scorecard">
                      <i className="ui icon print" />
                      <span className="nav-label">
                        {french ? 'Imprimez' : 'Print'}
                      </span>
                    </button>
                  </li>
                }
                position="right center"
                content={
                  isCompare
                    ? french
                      ? 'Ce bouton sert à afficher la fiche d’évaluation du portefeuille. Pour imprimer la comparaison des portefeuilles, veuillez utiliser le bouton « Imprimer » au bas de la page.'
                      : 'This button is for the Portfolio Scorecard. To print the Portfolio Comparison, please use the “Print” button at the bottom.'
                    : french
                    ? "Imprimez ou enregistrez cette fiche d'évaluation au format PDF"
                    : 'Print or save this scorecard as a PDF'
                }
                basic
                wide
              />

              {!this.hasTenGic() && reminderIsOpen && (
                <Popup
                  className="newPopup"
                  onClick={this.handleReminderClick}
                  trigger={
                    <li
                      onClick={this.handleCompareClick}
                      className={cn({
                        active:
                          window.location.pathname
                            .split('/')
                            .indexOf('compare') !== -1,
                      })}
                    >
                      <button>
                        <i className="ui icon law" />
                        <span className="nav-label">
                          {french ? 'Comparer' : 'Compare'}
                        </span>
                      </button>
                    </li>
                  }
                  position="bottom center"
                  open={reminderIsOpen}
                >
                  <Popup.Header>
                    {french ? 'Regardez ça !' : 'Check this out!'}
                  </Popup.Header>
                  <Popup.Content>
                    <br />
                    {french
                      ? 'Cliquez sur cette icône d\'échelle pour essayer notre fonction "Comparer/Et si".'
                      : 'Click this scale icon to try our “Compare/What-If” function.'}
                    <br />
                    <br />
                    <span
                      style={{
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}
                    >
                      {french ? 'Compris.' : 'Got it.'}
                    </span>
                  </Popup.Content>
                </Popup>
              )}
            </Feature>
          </ul>
        </Container>
        <SaveModal
          portfolio={portfolio}
          closeModal={this.closeModal}
          open={modalIsOpen === 'save'}
        />
      </div>
    );
  }
}

NBSideBar.propTypes = {
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  portfolio: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  hidden: PropTypes.bool,
  not_save_url_scorecard: PropTypes.bool,
  ui_compare_checked: PropTypes.bool,
  to_scorecard: PropTypes.bool,
  partnerName: PropTypes.string,
  french: PropTypes.bool,
};

NBSideBar.defaultProps = {
  hidden: false,
  not_save_url_scorecard: false,
  ui_compare_checked: false,
  to_scorecard: false,
  partnerName: '',
  french: false,
};

export default withRouter(
  connect((state) => ({
    editing: state.Portfolio.editing,
    not_save_url_scorecard: state.Storage.not_save_url_scorecard,
    ui_compare_checked: state.Storage.ui_compare_checked,
    to_scorecard: state.Storage.to_scorecard,
    partnerName: state.Storage['partner-name'],
    french: state.Storage.language === 'fr',
  }))(NBSideBar)
);

const Container = styled.div`
  display: ${(props) => (props.hidden ? 'none' : 'block')};
  position: fixed;
  top: 60px;
  left: 0;
  width: 4.8rem;
  height: 100%;
  background: ${nbColors.darkBlue};
  padding: 0;
  z-index: 2;

  ul {
    margin: 0;
    padding: 0.4rem 0;
    list-style: none;

    li {
      color: white;
      text-align: center;
      width: 3.4rem;
      margin: 0.2rem auto;
      padding: 0.6rem 0;
      font-size: 1.5rem;
      border-radius: 10px;
      transition: all 200ms ease;
      cursor: pointer;
      background: transparent;

      &.active {
        color: white;
        background: rgba(255, 255, 255, 0.15);
      }

      &.disabled {
        opacity: 0.5;
        color: white;
        cursor: default;
      }

      &:hover {
        color: white;
        background: rgba(255, 255, 255, 0.12);
      }

      button {
        background: transparent;
        border: none;
        outline: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        color: white;
        cursor: inherit;

        .nav-label {
          display: block;
          font-size: 12px;
          font-weight: 500;
          margin-top: 0.3rem;
          line-height: 1.2;
          letter-spacing: 0.02em;
          color: white;
          font-family: inherit;
        }

        svg {
          font-size: 1.5rem;
        }
      }
    }
  }

  i {
    margin: 0;
    width: fit-content;
    height: fit-content;
    color: white !important;
    font-size: 1.5rem;

    &.save {
      padding: 2px 4px;
    }

    &.pencil {
      padding: 2px 4px;
    }

    &.undo {
      padding: 2px 4px;
    }

    &.money {
      padding: 2px 1px;
    }

    &.law {
      font-size: 1.3rem;
      padding: 1px 0;
    }

    &.print {
      padding: 2px 4px;
    }
  }
`;
